<template>
    <b-modal v-model="modalShow" ref="modal-cancel" size="sm" title="Proposta Inadiplente">
        <b-form novalidate="novalidate" autocomplete="off">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group bmd-form-group is-filled"
                         v-bind:class="{'has-danger' : validation.in_default_at != ''}">
                        <label for="cancel_at" class="bmd-label-floating">Data</label>
                        <date-picker v-model="form.in_default_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                        <label v-if="validation.in_default_at != ''" id="in_default_at-error" class="error" for="in_default_at">{{ validation.in_default_at }}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group bmd-form-group"
                         v-bind:class="{'has-danger' : validation.observations != ''}">
                        <b-form-textarea
                            id="textarea"
                            v-model="form.observations"
                            placeholder="Observações..."
                            rows="3"
                            max-rows="6"
                            :state="validation.observations == ''"
                            ></b-form-textarea>
                        <label v-if="validation.observations != ''" id="observations-error" class="error" for="observations">{{ validation.observations }}</label>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer">
            <button @click="onSubmitInDefault" class="btn btn-rose btn-sm">
                <span class="btn-label">
                    <i class="material-icons">done</i>
                </span>
                Salvar
            </button>
            <b-button @click="goBack" size="sm">
                <span class="btn-label">
                    <i class="material-icons">{{ 'keyboard_arrow_left' }}</i>
                </span>
                {{ 'Voltar' }}
            </b-button> 
        </div>
    </b-modal>
</template>
<script>
    export default {
        data() {
            return {
                form: {
                    id: 0,
                    in_default_at: '',
                    observations: '',
                    proposal_status_id: 4
                },
                modalShow: true,
                validation: {
                    in_default_at: '',
                    observations: ''
                }
            };
        },
        mounted() {
            var self = this;

            self.form.id = self.$route.params.id;

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });
        },
        methods: {
            goBack() {
                var self = this;
                self.$router.push({'name': 'proposals.show', params: {'id': self.$route.params.id}});
            },
            onSubmitInDefault(_ev) {
                var self = this;
                var valid = true;

                self.validation = {
                    in_default_at: '',
                    observations: ''
                };

                _ev.preventDefault();

                if (self.form.in_default_at == '') {
                    self.validation.in_default_at = "Campo obrigatório!";
                    valid = false;
                }

                if (self.form.observations == '') {
                    self.validation.observations = "Campo obrigatório!";
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit("onLoading");

                    const response = self.$store.dispatch('proposals/edit', self.form);

                    response.then(function () {
                        self.$root.$emit("onLoading");
                        self.$notify.success("Proposta contemplada com sucesso!");
                        self.goBack();
                    });

                    response.catch(function (err) {
                        self.$root.$emit("onLoading");
                        if (err.status === 406 || err.status === 422) {
                            if (err.data.invoice_at !== undefined) {
                                self.validation.invoice_at = err.data.invoice_at[0];
                            }
                            if (err.data.observations !== undefined) {
                                self.validation.observations = err.data.observations[0];
                            }
                        }
                    });
                }
            }
        }
    };
</script>